module.exports = __webpack_public_path__ + "static/media/leclerc3.14e730ff.jpg";